import { Content } from '../../types';

export const khaoLakContent: Content = {
  title: 'קאו לאק – פנינת חוף קסומה בתאילנד',
  imageUrl: '/images/thailand/khao-lak/khao-lak-wide.jpeg',
  introduction:
    'קאו לאק, הינה רצועת חוף יפהפייה ותיירותית השוכנת לאורך כ-30 ק"מ לחופי ים אנדמן, כ-60 ק"מ צפונית לפוקט, במחוז פנג נה. האזור מציע שילוב מושלם של חופים זהובים, מים צלולים, ג\'ונגלים עבותים ואווירה שלווה, מה שהופך אותו ליעד אידיאלי לחופשה משפחתית רגועה. מצידה המזרחי של קאו לאק משתרעת רצועת הרים וג\'ונגלים ירוקים ומרהיבים, המספקים הזדמנות מושלמת לטיולי טבע, טרקטורונים וסיורים משפחתיים מרתקים.',
  sections: [
    {
      title: 'חופים מרכזיים בקאו לאק',
      type: 'sub-headers',
      description:
        'לאורך קאו לאק פרוסים ריזורטים ובתי מלון יוקרתיים הממוקמים בעיקר לצד ארבעת החופים המרכזיים, כל אחד מהם מציע חוויית נופש ייחודית:',
      content: [
        {
          subtitle: 'חוף Khao Lak',
          text: 'ממוקם בגבול הדרומי של האזור ומשמש נקודת כניסה ראשית לקאו לאק.',
        },
        {
          subtitle: 'חוף Nang Thong',
          text: 'ממוקם בכפר Bang La On ונחשב לחוף המרכזי של האזור, עם ריזורטים יוקרתיים ושפע של מסעדות, חנויות וחיי לילה נינוחים.',
        },
        {
          subtitle: 'חוף Bang Niang',
          text: 'ממוקם בכפר בעל שם זהה ונחשב גם הוא לחוף תיירותי משמעותי, בו ניתן למצוא את השוק הפופולרי של האזור.',
        },
        {
          subtitle: 'חוף Khuk Khak',
          text: 'החוף הצפוני ביותר מבין החופים המרכזיים, מציע אווירה שקטה ומבודדת יחסית.',
        },
      ],
    },
    {
      title: 'אטרקציות מומלצות בקאו לאק',
      type: 'sub-headers',
      description:
        'מלבד החופים המרהיבים, קאו לאק מציעה מגוון אטרקציות ייחודיות לכל המשפחה:',
      content: [
        {
          subtitle: 'שוק Bang Niang',
          text: 'אחד מהשווקים הגדולים והפופולריים באזור, פעיל בימים שני, רביעי, חמישי ושבת. השוק מציע מגוון דוכני אוכל מקומי, בגדים, מזכרות ומוצרי עבודת יד.',
        },
        {
          subtitle: 'מפלי Sai Rung',
          text: 'מפל יפהפה הנמצא בסביבה טרופית ירוקה, אידיאלי לטיול טבע קצר ומרענן.',
        },
        {
          subtitle: 'נהר Takua Pa (המכונה "The Little Amazon")',
          text: "חוויה מדהימה של שיט בסירת מנוע או קאנו בנהר המוקף בצמחייה טרופית עשירה, המעניקה תחושה של מסע בג'ונגל פראי.",
        },
      ],
    },
    {
      title: 'טיולי יום פופולריים מקאו לאק',
      type: 'sub-headers',
      description:
        'קאו לאק מהווה נקודת יציאה נוחה לשלושה מהטיולים האטרקטיביים ביותר בתאילנד:',
      content: [
        {
          subtitle: 'איי סימילאן',
          text: 'קבוצת איים יפיפיים עם חופים לבנים ומים צלולים, מהטובים בעולם לצלילה ושנורקלינג.',
        },
        {
          subtitle: 'איי סורין',
          text: 'יעד מומלץ נוסף לחובבי הצלילה והשנורקלינג, עם עולם תת-ימי עשיר ושוניות אלמוגים מרהיבות.',
        },
        {
          subtitle: "שמורת קאו סוק ואגם צ'או לאן",
          text: "שמורת טבע מרהיבה המשלבת ג'ונגלים, נהרות וצוקים מרשימים, עם אפשרות ללינה בצימרים צפים על אגם צ'או לאן.",
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, קאו לאק הינו יעד מושלם למחפשים חופשה שקטה עם חופים חלומיים, טבע עשיר ואטרקציות ייחודיות. בין אם אתם מטיילים בזוג, עם ילדים או מחפשים חוויות אקסטרים בטבע, קאו לאק מציעה שילוב מנצח של רוגע, יוקרה והרפתקאות בלתי נשכחות.',
    },
  ],
};
